import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialDeepScanState = {
  sortableFields: [],
  filterableFields: [],
  initialDisplayFields: [],
  defaultDisplayFields: [],
  fieldsMetadata: {},
  results: {},
  resultsStatus: STATUS.IDLE,
  query: '',
  sorting: ['scan_date/desc'],
  currentPage: 1,
  availableFields: [],
  spqlQueryValidationMessage: '',
  queryExamples: [],
  queryExamplesStatus: STATUS.IDLE,
  recentlyRanQueries: [],
  recentlyRanQueriesStatus: STATUS.IDLE,
  savedSPQLQueries: [],
  savedSPQLQueriesStatus: STATUS.IDLE,
  saveSPQLQueryStatus: STATUS.IDLE,
  saveSPQLQueryError: null,
};

function getSPQLFieldsFromResults(results) {
  if (!results) return [];
  const data = results.data ?? [];
  const keys = [
    ...new Set(data.slice(0, 3).flatMap((row) => Object.keys(row))),
  ];
  return keys;
}

export default (state = initialDeepScanState, action) => {
  switch (action.type) {
    case types.SET_CREATE_SPQL_QUERY_STATUS:
      return {
        ...state,
        saveSPQLQueryStatus: action.payload,
      };
    case types.CHANGE_SPQL_QUERY_VALIDATION_MESSAGE:
      return {
        ...state,
        spqlQueryValidationMessage: action.payload,
      };
    case types.RESET_DEEP_SCAN_TO_INITIAL_STATE:
      return {
        ...initialDeepScanState,
        savedSPQLQueries: [...state.savedSPQLQueries],
        savedSPQLQueriesStatus: state.savedSPQLQueriesStatus,
        recentlyRanQueries: [...state.recentlyRanQueries],
        recentlyRanQueriesStatus: state.recentlyRanQueriesStatus,
        queryExamples: [...state.queryExamples],
        queryExamplesStatus: state.queryExamplesStatus,
        fieldsMetadata: { ...state.fieldsMetadata },
        sortableFields: state.sortableFields,
        initialDisplayFields: [...state.initialDisplayFields],
        defaultDisplayFields: [...state.initialDisplayFields],
      };
    case types.CHANGE_SPQL_SELECTED_COLUMNS:
      return {
        ...state,
        defaultDisplayFields: action.payload,
      };
    case types.CHANGE_SPQL_SORTING:
      return {
        ...state,
        sorting: action.payload,
      };
    case types.CHANGE_SPQL_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case resolve(types.DELETE_SPQL_QUERY):
      return {
        ...state,
        saveSPQLQueryStatus: STATUS.IDLE,
        savedSPQLQueries: state.savedSPQLQueries.filter(
          (query) => query.uuid !== action.payload,
        ),
      };
    case reject(types.DELETE_SPQL_QUERY):
      return {
        ...state,
      };
    case types.UPDATE_SPQL_QUERY:
      return {
        ...state,
        saveSPQLQueryStatus: STATUS.LOADING,
        saveSPQLQueryError: null,
      };
    case resolve(types.UPDATE_SPQL_QUERY):
      return {
        ...state,
        savedSPQLQueries: state.savedSPQLQueries.map((query) => {
          if (query.uuid === action.payload.uuid) {
            return action.payload;
          }
          return query;
        }),
        saveSPQLQueryStatus: STATUS.SUCCESS,
        saveSPQLQueryError: null,
      };
    case reject(types.UPDATE_SPQL_QUERY):
      return {
        ...state,
        saveSPQLQueryStatus: STATUS.ERROR,
        saveSPQLQueryError: action.error,
      };
    case types.CREATE_SPQL_QUERY:
      return {
        ...state,
        saveSPQLQueryStatus: STATUS.LOADING,
      };
    case resolve(types.CREATE_SPQL_QUERY):
      return {
        ...state,
        savedSPQLQueries: [action.payload, ...state.savedSPQLQueries],
        saveSPQLQueryError: null,
        saveSPQLQueryStatus: STATUS.SUCCESS,
      };
    case reject(types.CREATE_SPQL_QUERY):
      return {
        ...state,
        saveSPQLQueryStatus: STATUS.ERROR,
        saveSPQLQueryError: action.error,
      };
    case types.GET_SAVED_SPQL_QUERIES:
      return {
        ...state,
        savedSPQLQueries: [],
        savedSPQLQueriesStatus: STATUS.LOADING,
      };
    case types.GET_QUERY_EXAMPLES:
      return {
        ...state,
        queryExamples: [],
        queryExamplesStatus: STATUS.LOADING,
      };
    case resolve(types.GET_QUERY_EXAMPLES):
      return {
        ...state,
        queryExamples: action.payload,
        queryExamplesStatus: STATUS.SUCCESS,
      };
    case resolve(types.GET_SAVED_SPQL_QUERIES):
      return {
        ...state,
        savedSPQLQueries: action.payload,
        savedSPQLQueriesStatus: STATUS.SUCCESS,
      };
    case types.GET_RECENTLY_RAN_SPQL_QUERIES:
      return {
        ...state,
        recentlyRanQueries: [],
        recentlyRanQueriesStatus: STATUS.LOADING,
      };
    case resolve(types.GET_RECENTLY_RAN_SPQL_QUERIES):
      return {
        ...state,
        recentlyRanQueriesStatus: STATUS.SUCCESS,
        recentlyRanQueries: action.payload,
      };
    case types.GET_DEEP_SCAN:
      return {
        ...state,
        resultsStatus: STATUS.LOADING,
      };
    case resolve(types.GET_DEEP_SCAN):
      return {
        ...state,
        spqlQueryValidationMessage: '',
        resultsStatus: STATUS.SUCCESS,
        recentlyRanQueries: [
          { query: action.payload.query },
          ...state.recentlyRanQueries.filter(
            (query) => query.query !== action.payload.query,
          ),
        ].splice(0, 10),
        currentPage: action.payload.currentPage,
        results: action.payload,
        availableFields: getSPQLFieldsFromResults(action.payload),
      };
    case resolve(types.GET_DEEP_SCAN_METADATA):
      return {
        ...state,
        sortableFields: action.payload?.sortable_fields,
        filterableFields: action.payload?.filterable_fields,
        initialDisplayFields: [
          ...(action.payload?.default_display_fields ?? []),
        ],
        defaultDisplayFields: action.payload?.default_display_fields,
        fieldsMetadata: action.payload?.fields_metadata,
      };
    case reject(types.GET_DEEP_SCAN_METADATA):
      return {
        ...state,
        status: STATUS.ERROR,
      };
    default:
      return state;
  }
};
